import { HoverCardWithLink } from '@/components/hover-card-with-link';
import { AppRoute, STAKING_URL } from '@/constants/shared';
import { AspectRatio, Flex, Heading, SimpleGrid, VStack } from '@chakra-ui/react';
import { LottieReact } from '@lottielab/lottie-player';

type Action = {
  href: string;
  lottie: string;
  mobileIcon: React.ReactNode;
  label: string;
};

const actions: Action[] = [
  {
    href: AppRoute.BridgeWithDefaults,
    lottie: 'https://cdn.lottielab.com/l/7oyfUv4GBA14cy.json',
    mobileIcon: (
      <svg xmlns="http://www.w3.org/2000/svg" width="35" height="35" viewBox="0 0 35 35" fill="none">
        <path
          d="M9.03125 7.20947H27.5938C28.4143 7.20947 29.2012 7.53542 29.7814 8.11561C30.3616 8.6958 30.6875 9.48271 30.6875 10.3032V24.2251C30.6875 24.6354 30.5245 25.0288 30.2344 25.3189C29.9443 25.609 29.5509 25.772 29.1406 25.772H26.0469C25.6366 25.772 25.2432 25.609 24.9531 25.3189C24.663 25.0288 24.5 24.6354 24.5 24.2251V21.1313C24.5 19.4903 23.8481 17.9165 22.6877 16.7561C21.5273 15.5957 19.9535 14.9438 18.3125 14.9438C16.6715 14.9438 15.0977 15.5957 13.9373 16.7561C12.7769 17.9165 12.125 19.4903 12.125 21.1313V24.2251C12.125 24.6354 11.962 25.0288 11.6719 25.3189C11.3818 25.609 10.9884 25.772 10.5781 25.772H7.48438C7.07412 25.772 6.68066 25.609 6.39057 25.3189C6.10047 25.0288 5.9375 24.6354 5.9375 24.2251V10.3032C5.9375 9.48271 6.26345 8.6958 6.84364 8.11561C7.42383 7.53542 8.21074 7.20947 9.03125 7.20947Z"
          fill="#747474"
          stroke="#747474"
          strokeWidth="2"
        />
      </svg>
    ),
    label: 'Bridge',
  },
  {
    href: AppRoute.Swap,
    lottie: 'https://cdn.lottielab.com/l/AgP8tNat8izUBm.json',
    mobileIcon: (
      <svg xmlns="http://www.w3.org/2000/svg" width="35" height="35" viewBox="0 0 35 35" fill="none">
        <path
          d="M14.2969 5.52197L6.54222 13.2766C6.29023 13.5286 6.4687 13.9595 6.82506 13.9595H29.4844"
          stroke="#747474"
          strokeWidth="4"
          strokeLinecap="round"
        />
        <path
          d="M21.0469 29.147L28.8015 21.3923C29.0535 21.1403 28.8751 20.7095 28.5187 20.7095H5.85938"
          stroke="#747474"
          strokeWidth="4"
          strokeLinecap="round"
        />
      </svg>
    ),
    label: 'Swap',
  },
  {
    href: STAKING_URL,
    lottie: 'https://cdn.lottielab.com/l/23SHqH3DDzHgvT.json',
    mobileIcon: (
      <svg xmlns="http://www.w3.org/2000/svg" width="35" height="35" viewBox="0 0 35 35" fill="none">
        <path d="M23.5421 12.4212V22.1121L19.7378 18.2762V8.58526L23.5421 12.4212Z" fill="#747474" />
        <path d="M12.9361 23.1207H22.5423L18.7399 19.2829H9.13371L12.9361 23.1207Z" fill="#747474" />
        <path
          d="M28.9491 28.6093V17.8758L25.1448 14.0399V24.7734L14.5407 24.7375L18.343 28.5754L28.9471 28.6112"
          fill="#747474"
        />
        <path
          d="M4.24988 3.83632L4.24988 14.5698L8.05417 18.4057L8.05417 7.67221L18.6583 7.70804L14.856 3.87018L4.2519 3.83435"
          fill="#747474"
        />
        <path
          d="M29.9549 30.6477L27.7966 28.4703L28.8449 27.4128L31.0032 29.5901L31.2499 30.8344L29.9549 30.6477Z"
          fill="#747474"
        />
      </svg>
    ),
    label: 'Stake',
  },
  {
    href: AppRoute.Quests,
    lottie: 'https://cdn.lottielab.com/l/7Ayz8W2GKeCbgo.json',
    mobileIcon: (
      <svg xmlns="http://www.w3.org/2000/svg" width="35" height="34" viewBox="0 0 35 34" fill="none">
        <path
          d="M27.1868 14.5976L17.4635 18.0588C17.3269 18.1044 17.1902 18.1044 17.0764 18.0588L7.3303 14.5976C6.80657 14.4154 6.80657 13.6868 7.3303 13.5046L17.0536 10.0206C17.1902 9.97506 17.3269 9.97506 17.4407 10.0206L27.1868 13.5046C27.6877 13.6868 27.6877 14.4154 27.1868 14.5976ZM26.4809 18.5598V16.0777L25.3195 16.4876V18.6053C25.0918 18.7875 24.9324 19.0835 24.9324 19.4023C24.9324 19.9716 25.3879 20.4043 25.9344 20.4043C26.4809 20.4043 26.9363 19.9488 26.9363 19.4023C26.9363 19.038 26.7541 18.7192 26.4809 18.5598ZM17.2585 19.2657C17.0536 19.2657 16.8487 19.2429 16.6665 19.1746L10.4044 16.943V21.7933C14.4805 24.7536 20.0139 24.7536 24.0899 21.7933V16.9203L17.8506 19.1519C17.6456 19.2202 17.4635 19.2657 17.2585 19.2657Z"
          fill="#747474"
        />
      </svg>
    ),
    label: 'Level Up',
  },
];
export const ActionsSection = () => {
  return (
    <SimpleGrid
      columns={{
        base: 2,
        lg: 4,
      }}
      w="full"
      gap={4}
    >
      {actions.map((action) => (
        <ActionCard key={action.href} {...action} />
      ))}
    </SimpleGrid>
  );
};

const ActionCard = ({ href, lottie, label, mobileIcon }: Action) => {
  return (
    <HoverCardWithLink
      href={href}
      showHoverIcon={false}
      linkProps={{ minH: ['auto', 'auto', '184px'] }}
      cardRootStyles={{
        w: 'full',
        rounded: ['12px', '12px', '3xl'],
      }}
    >
      <VStack hideFrom="md" gap={6} bgColor="#EFEEEB" p={6}>
        <Flex p={2.5} rounded="12px" bgColor="bg">
          {mobileIcon}
        </Flex>
        <Heading size="2xl" fontWeight="700" lineHeight="32px" letterSpacing="-0.47px">
          {label}
        </Heading>
      </VStack>
      <AspectRatio ratio={277 / 184} hideBelow="md" bgColor="#EFEEEB">
        <LottieReact src={lottie} />
      </AspectRatio>
    </HoverCardWithLink>
  );
};
